define('apps/course-intro/templates/intro',['handlebars'], function(Handlebars) {

return Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<section class=\"content-region\"></section>\n<div class=\"fixed-top\">\n    <header class=\"header-region\"></header>\n    <nav class=\"nav-region\"></nav>\n</div>\n<div class=\"loading-overlay hide\">\n    <span class=\"fa fa-circle-o-notch fa-spin\"></span>\n</div>\n";
  })

});
